import { render, staticRenderFns } from "./notice-component.vue?vue&type=template&id=6ca8bf0a&scoped=true&"
import script from "./notice-component.vue?vue&type=script&lang=js&"
export * from "./notice-component.vue?vue&type=script&lang=js&"
import style0 from "./notice-component.vue?vue&type=style&index=0&id=6ca8bf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca8bf0a",
  null
  
)

export default component.exports